// extracted by mini-css-extract-plugin
export var configurationSection = "_rl-0";